/**
 * Created by Administrador on 20/11/2017.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('cargoParameters', {
                parent: 'app',
                url: '/cargoParameters',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/configCargo/cargoParameter/cargoParameters.html',
                        controller: 'cargoParameterCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['cargoParameter']);
                            }],
                            cargoParameters: ['cargoParameterService', function (cargoParameterService) {
                                return cargoParameterService.getCargoParameterList();
                            }]
                        }
                    }
                }
            })
            .state('cargoParameterNew', {
                parent: 'app',
                url: '/cargoParameter/new',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/configCargo/cargoParameter/newCargoParameter.html',
                        controller: 'newEditCargoParameterCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabAdminClassifications('cargoParameters')
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['cargoParameter']);
                            }],
                            action: [function () {
                                return "new";
                            }],
                            cargoParameter: [function () {
                                return null;
                            }]
                        }
                    }
                }
            })
            .state('cargoParameterDelete', {
                parent: 'cargoParameters',
                url: '/cargoParameter/:id/delete',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/configCargo/cargoParameter/deleteParameter.html',
                        controller: 'deleteParameterCtrl',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            cargoParameter: ['cargoParameterService', function (cargoParameterService) {
                                return cargoParameterService.getParameter($stateParams.id)
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['cargoParameter']);
                            }]
                        }
                    }).result.then(function () {
                        $state.go('cargoParameters', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }
})();
